const config = {
  apiBaseUrl:
    process.env.REACT_APP_API_BASE_URL || "https://api.core-test.lutiband.com/",
};

export default config;
